import styled from "styled-components";

export const Container = styled.main`
    display: flex;
    flex-direction: column;
    gap: 20px;

    background-color: ${(props) => props.theme.colors.white};
    box-shadow: 1px 2px 4px 0px ${(props) => props.theme.colors.gray.gray_100};
    border: 1px solid ${(props) => props.theme.colors.gray.gray_50};
    padding: 10px;
    border-radius: 4px;
`;

export const ContentPayment = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;

`;

export const ContentButton = styled.div`
    display: flex;
    `;

export const Button = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;

    color: ${(props) => props.theme.colors.gray.gray_200};
    border: 1px solid ${(props) => props.theme.colors.gray.gray_100};
    
    padding: 2px 6px;
    border-radius: 4px;
    
    &:hover{
        color: ${(props) => props.theme.colors.gray.gray_600};
        background-color: ${(props) => props.theme.colors.gray.gray_50};
    }
`;

export const ButtonRemove = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;

    color: ${(props) => props.theme.colors.primary};
    background-color: ${(props) => props.theme.colors.red.red_50};
    
    padding: 4px 8px;
    border-radius: 30px;
    
    &:hover{
        color: ${(props) => props.theme.colors.red.red_800};

    }
`;

export const SeparateDiv = styled.div`
    display: flex;
    gap: 20px;
    
    @media (max-width: 780px) {
        flex-direction: column;
        gap: 10px;
    }
`;

export const FormInput = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    input{
        &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
        border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
        padding: 10px;
        width: 100%;
    }
`;

export const Label = styled.label`
    color: ${(props) => props.theme.colors.gray.gray_800};
    font-size: 14px;
    
    span{
        color: ${(props) => props.theme.colors.primary};
        margin-left: 3px;
    }
`;

export const Input = styled.input`
    &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    padding: 10px;
    width: 100%;
`;

export const InforErro = styled.div`
    color: ${(props) => props.theme.colors.primary};
    font-size: 12px;
`;

export const ContentInput = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    padding: 10px;
`;

export const Select = styled.select`
    background-color: ${(props) => props.theme.colors.white};
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    padding: 10px;
    width: 100%;
`;